import React from 'react';
import ReactDOM from "react-dom/client";
import './assets/styles/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from "react-router-dom";
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from "./Theme";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
            <App />
        </Router>
    </MuiThemeProvider>
);

serviceWorker.unregister();